import { useState } from "react"

import type { Product } from "@/graphql/codegen/graphql"
import type { PricingDialogs, RecipientType } from "@/screens/Pricing/constants"

interface UsePricingModalReturn {
  isDialogOpen: PricingDialogs | null
  selectedProduct: Product | null
  selectedRecipientType: RecipientType | null
  selectedSubmissionId: string | null
  setSelectedProduct: (product: Product | null) => void
  setSelectedSubmissionId: (submissionId: string | null) => void
  setSelectedRecipientType: (recipientType: RecipientType | null) => void
  setIsDialogOpen: (dialog: PricingDialogs | null) => void
}

export const usePricingDialog = (): UsePricingModalReturn => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null)
  const [selectedSubmissionId, setSelectedSubmissionId] = useState<string | null>(null)
  const [isDialogOpen, setIsDialogOpen] = useState<PricingDialogs | null>(null)
  const [selectedRecipientType, setSelectedRecipientType] = useState<RecipientType | null>(null)

  return {
    selectedProduct,
    isDialogOpen,
    setSelectedProduct,
    setIsDialogOpen,
    setSelectedSubmissionId,
    setSelectedRecipientType,
    selectedSubmissionId,
    selectedRecipientType,
  }
}
